import React from 'react';
export function AboutSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-20">
      <div className="max-w-3xl mx-auto text-center" data-id="element-21">
        <div className="text-4xl mb-6" data-id="element-22">🧘‍♀️</div>
        <h2 className="text-3xl font-black text-brand-text mb-8" data-id="element-23">
          A proposito di EduLabs Italia
        </h2>
        <p className="text-lg text-brand-gray leading-relaxed" data-id="element-24">
          Da EduLabs Italia creiamo risorse pratiche per insegnanti che vogliono
          insegnare meglio e vivere del proprio lavoro. Sappiamo cosa significa
          correre da uno studio all'altro, preparare lezioni alle undici di sera
          e sentire che l'impegno non basta mai. Yoga Pronta è il sistema che
          avremmo voluto avere quando abbiamo iniziato.
        </p>
      </div>
    </section>;
}